
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Venue } from '@/interfaces/models/Venue';
import { venueFilter } from '@/util/helper';

@Component
export default class ConstrainFilter extends Vue {
  public search: string = '';

  public onSearch() {
    this.$emit('search', this.search);
  }
}
